import React from 'react';
import {Header} from './Components/Header/Header';
import {classes, st} from './SideCart.st.css';
import {Footer} from './Components/Footer/Footer';
import {Body} from './Components/Body/Body';
import './vars.css';

export const SideCart = () => {
  return (
    <main className={st('cartBodyMainOneColumn', 'sideCart', classes.container)}>
      <div className={classes.headerAndBody}>
        <Header />
        <Body />
      </div>
      <div className={classes.footer}>
        <Footer />
      </div>
    </main>
  );
};
